const isMobileDevicePattern = `Mobile|webOS|BlackBerry|edge|IEMobile|MeeGo|
mini|Fennec|Windows Phone|Android|iP(ad|od|hone)`;
const isMobileDeviceRegExp = new RegExp(isMobileDevicePattern, 'i');

export const isMobileDevice = isMobileDeviceRegExp.test(navigator.userAgent.toLowerCase());
